import { plainToClass } from "class-transformer";
import { JsonItem, AppUserRedacted, PickListItem } from "../../../../secure/list-management/scripts/list-management.objects";

declare var $: any;
export class UserDegreesPage {
    currentAppUser: AppUserRedacted;
    initialDegrees: string[] = [];
    degreeSelect: JQuery<HTMLElement>;
    pickLists: JsonItem[];

    constructor(entity: any, pickLists: any) {
        $(() => {
            this.currentAppUser = plainToClass(AppUserRedacted, <AppUserRedacted>entity);
            this.pickLists = plainToClass(JsonItem, <JsonItem[]>pickLists);
            this.degreeSelect = $("#degree-dropdown");
            if (this.currentAppUser.TerminalDegreeIds) {
                this.initialDegrees = this.currentAppUser.TerminalDegreeIds.split("|");
            }
            else {
                this.initialDegrees = [];
            }

            this.initializeDropdown();
        });
    }

    initializeDropdown(): void {
        let degreePickList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-degrees").Json;
        let degreeOptions: string[][] = [];
        degreePickList.forEach(item => {
            degreeOptions.push([item.Id.toString(), item.Value]);
        })

        this.degreeSelect.selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });

        degreeOptions.sort((x1: string[], x2: string[]) => x1[1].localeCompare(x2[1]));
        degreeOptions.forEach((element: any[]) => {
            let selected = false;
            let optionId = element[0];
            if (this.initialDegrees.includes(optionId)) {
                selected = true;
            }
            this.degreeSelect.append(new Option(element[1], element[0], false, selected));
        });

        this.degreeSelect.selectpicker("refresh");
    }

    async updateDegrees(): Promise<any> {
        // Show Saving
        let successModal = $("#success-modal");
        successModal.find("#saving-content").removeClass("d-none");
        successModal.find("#success-content").addClass("d-none");
        successModal.find(".modal-header").addClass("d-none");
        successModal.modal("show");

        let result = await this.saveDegrees();

        // Show Saved
        successModal.find("#saving-content").addClass("d-none");
        successModal.find("#success-content").removeClass("d-none");
        successModal.find(".modal-header").removeClass("d-none");  
    }

    async saveDegrees(): Promise<any> {
        let selectedOptions = this.degreeSelect.val();
        let updatedDegrees = "";
        if (selectedOptions) {
            let selectedArr = <string[]>selectedOptions;
            updatedDegrees = selectedArr.join("|");
        }

        this.currentAppUser.TerminalDegreeIds = updatedDegrees;
        let updatedUser: AppUserRedacted = this.currentAppUser;

        let result: Promise<any>;
        try {
            result = await $.ajax({
                url: `/auth/pages/profile/user-degrees?handler=SaveDegrees`,
                method: "POST",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(updatedUser) },
            })
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }
}